// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { SvgContainer } from 'common/styles/oc-styled-components';

// Other
import { colors } from 'common/styles/style-constants';

// Component
const PatientsChoiceSvg = ({ height, margin, width }) => (
  <SvgContainer
    color={colors.coral}
    height={height}
    margin={margin}
    width={width}
  >
    <svg
      width="22px"
      height="22px"
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
    >
      <g
        id="Search_Results"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Practice-Badges-Profile"
          transform="translate(-34.000000, -1455.000000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <g id="PatientsChoice" transform="translate(25.000000, 1446.000000)">
            <path
              d="M25.2265625,30.5 C25.8515625,30.5 26.3671875,30.2617188 26.7734375,29.7851562 C27.1796875,29.3085938 27.3359375,28.7578125 27.2421875,28.1328125 L26.3984375,23.0234375 L29.9375,19.4140625 C30.203125,19.1328125 30.375,18.8125 30.453125,18.453125 C30.546875,18.078125 30.53125,17.7070312 30.40625,17.3398438 C30.28125,16.9726562 30.0742188,16.6679688 29.7851562,16.4257812 C29.4960938,16.1835938 29.1640625,16.03125 28.7890625,15.96875 L23.984375,15.2421875 L21.828125,10.671875 C21.65625,10.296875 21.3984375,10.0078125 21.0546875,9.8046875 C20.7265625,9.6015625 20.375,9.5 20,9.5 C19.625,9.5 19.2734375,9.6015625 18.9453125,9.8046875 C18.6015625,10.0078125 18.34375,10.296875 18.171875,10.671875 L16.015625,15.2421875 L11.2109375,15.96875 C10.8359375,16.03125 10.5039062,16.1835938 10.2148438,16.4257812 C9.92578125,16.6679688 9.71875,16.9726562 9.59375,17.3398438 C9.46875,17.7070312 9.44921875,18.0742188 9.53515625,18.4414062 C9.62109375,18.8085938 9.796875,19.1328125 10.0625,19.4140625 L13.6015625,23.0234375 L12.7578125,28.1328125 C12.6640625,28.7578125 12.8203125,29.3085938 13.2265625,29.7851562 C13.6328125,30.2617188 14.1484375,30.5 14.7734375,30.5 C15.1171875,30.5 15.4453125,30.4140625 15.7578125,30.2421875 L20,27.8984375 L24.2421875,30.2421875 C24.5546875,30.4140625 24.8828125,30.5 25.2265625,30.5 Z"
              id=""
            />
          </g>
        </g>
      </g>
    </svg>
  </SvgContainer>
);

PatientsChoiceSvg.propTypes = {
  height: PropTypes.string,
  margin: PropTypes.string,
  width: PropTypes.string,
};

export default PatientsChoiceSvg;
